export const environment = {
  production: false,
  tenant: {
    id: 'demo',
    name: 'PPS Demo'
  },
  externalCrm: true,
  rest: {
    apiUrl: 'rms-demo.wmedia-di.de',
    protocol: 'https',
    port: 443,
    basePath: '/v1',
    uploadBaseUrl: ''
  },
  auth: {
    apiUrl: 'auth-demo.wmedia-di.de',
    protocol: 'https',
    port: 443
  },
  crm: {
    apiUrl: 'pps-demo.wmedia-di.de/crmapi',
    protocol: 'https',
    port: 443
  },
  versions: {
    npm: '9.6.7',
    node: 'v18.17.1 (LTS)',
    clarity: '17.6'
  },
  stages: {
    name: "  DEMO DEV !",
    dev: true,
  }
};
